import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchGroups(ctx, queryParams) {
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/groups/v1/getall',data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        addGroup(ctx, queryParams){
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/groups/v1/add',data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })

        },
        updatePermission(ctx, queryParams){
            console.log('queryParams',queryParams);
             var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                axios
                  .put(`/groups/v1/updateroles/${queryParams.id}`, queryParams.data)
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })

        },
        updateGroup(ctx, queryParams){
            console.log('queryParams',queryParams);
             var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                axios
                  .put('/groups/v1/update/'+queryParams.id,data)
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })

        },
        fetchDeleteGroup(ctx,id){
            return new Promise((resolve, reject) => {
                axios
                  .delete('/groups/v1/delete/'+id)
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
        }
    }
}